import { AxiosError } from 'axios';
import styled from 'styled-components';

import { Alert, AlertSize } from '@creditornot/cb-alert';

import { useLocalizedExpectedError } from './hooks';
import { ErrorCode, ErrorFormatter, LocaleKeyFormatter } from './types';
import { ExpectedError } from '../../../types';
import { ContentContainer } from '../ContentContainer';

const StyledAlert = styled(Alert)`
  white-space: pre-line;
  overflow-wrap: break-word;
  flex-basis: 100%;
`;

export type ExpectedApiErrorNotificationProps<T extends ErrorCode> = {
  error?: AxiosError<ExpectedError<T>> | null | unknown;
  toLocaleKey: LocaleKeyFormatter;
  formatter?: ErrorFormatter<T>;
  size?: AlertSize;
  className?: string;
};

export const ExpectedApiErrorNotification = <T extends ErrorCode>({
  error,
  toLocaleKey,
  formatter,
  size,
  className,
}: ExpectedApiErrorNotificationProps<T>) => {
  const errorMessage = useLocalizedExpectedError(toLocaleKey, error, formatter);

  if (!error) return null;

  return (
    <StyledAlert variant="error" size={size} className={className}>
      {Array.isArray(errorMessage) ? errorMessage.join('\n') : errorMessage}
    </StyledAlert>
  );
};

export const ExpectedPageApiError = <T extends ErrorCode>({
  error,
  toLocaleKey,
  formatter,
}: Omit<ExpectedApiErrorNotificationProps<T>, 'size' | 'classname'>) => {
  if (!error) return null;

  return (
    <ContentContainer>
      <ExpectedApiErrorNotification error={error} toLocaleKey={toLocaleKey} formatter={formatter} />
    </ContentContainer>
  );
};
